import {
  GET_COUNTY_DETAILS,
  GET_POWER_OUTAGE_REFRESH_MAP,
} from "./actions.type";
import {
  SET_COUNTY_DETAILS,
  SET_POWER_OUTAGE_REFRESH_MAP,
} from "./mutations.type";

import { getCounty } from "@/services/powerOutage/powerOutage.service";

const STATE = {
  details: {
    title: null,
  },
  refreshMap: false,
};

const GETTERS = {
  details: (state) => state.details,
  refreshMap: (state) => state.refreshMap,
};

const ACTIONS = {
  async [GET_COUNTY_DETAILS](context, data) {
    if (data.feature.properties.i && data.feature.properties.i) {
      const details = await getCounty({
        fips: data.feature.properties.i,
        type: data.feature.properties.t,
      });
      context.commit(SET_COUNTY_DETAILS, details);
    }
    return Promise.resolve(true);
  },
  [GET_POWER_OUTAGE_REFRESH_MAP](context, params) {
    context.commit(SET_POWER_OUTAGE_REFRESH_MAP, params);
  },
};

const MUTATIONS = {
  [SET_COUNTY_DETAILS](state, data) {
    state.details = data;
  },
  [SET_POWER_OUTAGE_REFRESH_MAP](state, data) {
    state.refreshMap = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
